'use strict';

import {convertDataVToVue} from '../apply_vue_data_directives.js';
import {SafetyTips} from './safetytips.js';

export class SafetytipsVap extends SafetyTips {
	constructor(component_key) {
		super(component_key);
		this.id = component_key;
		this.data = yalwa.v.components[component_key];
		this.$root = document.querySelector(`.js-${this.id}`);
	}
	
	async init() {}
	vue_setup(Vue) {
		this.Vue = Vue;
		const ythis = this;
		if (!this.$root) {
			console.error(`SafetytipsVap container not found for ID: ${this.id}`);
			return {};
		}
		const template =  `${convertDataVToVue(this.$root)}`;
		return ythis.Vue.defineComponent({
			name: ythis.id,
			template,
			setup() {
				const tips = ythis.Vue.ref(ythis.data.tips);
				const currentIndex = ythis.Vue.ref(0);
				
				const totalTips = ythis.Vue.computed(() => tips.value.length);
				const currentTipText = ythis.Vue.computed(() => tips.value[currentIndex.value]);
				
				const nextTip = () => {
					currentIndex.value = (currentIndex.value + 1) % totalTips.value;
				};
				
				const prevTip = () => {
					currentIndex.value = (currentIndex.value - 1 + totalTips.value) % totalTips.value;
				};
				
				return {
					tips,
					currentIndex,
					totalTips,
					currentTipText,
					nextTip,
					prevTip
				};
			}
		});
	}
}
